<!-- src/components/MobileHeaderNav.vue -->
<template>
  <div id="MobileHeaderNav">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <ul class="header-nav">
            <li><RouterLink class="active-nav" to="/">betting</RouterLink></li>
            <li><RouterLink to="/virtual-lobby">Virtuals</RouterLink></li>
            <li><RouterLink to="/crash-games">Crash</RouterLink></li>
            <li><RouterLink to="/instant-games">Instant</RouterLink></li>
            <li><RouterLink to="/casino-games">Casino</RouterLink></li>
            <li><RouterLink to="/promotions">Promotions</RouterLink></li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
</script>
